import { AccountDetails, useGetMerchantInfo } from 'helpers/useGetMerchantInfo';

type GeoCode = {
  latitude: number;
  longitude: number;
};

type GeoViewPort = GeoCode & {
  width: number | string;
  height: number | string;
  zoom: number;
};

type PlaceCategory = {
  code: string;
  description: string | null;
  type: string;
};

type Place = {
  name: string;
  dataSource: string;
  externalId: string;
  uuid?: string;

  address: {
    street: string;
    suite?: string;
    city: string;
    state: string;
    postal: string;
    country: string;
  };
  geocode: GeoCode;
  categoriesV2: PlaceCategory[];
};

type PlacesServiceParams = {
  merchantUuid: string;
  name: string;
  limit: number;
  geocodeFilter?: GeoCode;
  categoriesFilter?: string[];
  offset?: number;
  filters?: {
    state?: string;
    city?: string;
  };
};

type QueryResponse = {
  loading: boolean;
  data: {
    getPlaces: {
      places: Place[];
      nextPage: boolean;
    };
  };
};

type MerchantInfo = {
  merchantAcctDetails: AccountDetails;
  loading: boolean;
};

const DEFAULT_GEO_CODE = {
  latitude: 40,
  longitude: -96,
};

const DEFAULT_ZOOM = 3;

const DEFAULT_GEO_VIEWPORT = {
  width: '100%',
  height: 650,
  ...DEFAULT_GEO_CODE,
  zoom: DEFAULT_ZOOM,
};

const MIN_VENUE_LIMIT = 5;

// scale by 20% or a min of 5
const getMinLimit = (numPlaces: number) =>
  Math.max(Math.ceil(numPlaces * 1.2), MIN_VENUE_LIMIT);

export {
  GeoCode,
  GeoViewPort,
  Place,
  PlacesServiceParams,
  QueryResponse,
  MerchantInfo,
  DEFAULT_GEO_CODE,
  DEFAULT_GEO_VIEWPORT,
  getMinLimit,
  useGetMerchantInfo,
};
